import * as React from "react"

interface Props {
    width?: number
    height?: number
}

export default function ConnectIcon({width, height}:Props){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="#cccccc">
            <circle cx="12" cy="12" r="0">
                <animate attributeName="opacity" values="0;1;0"
                        keyTimes="0;.05;1" calcMode="linear"
                        dur="1.5s" repeatCount="indefinite"/>
                <animate attributeName="r" from="0" to="12"
                        dur="1.5s" repeatCount="indefinite"/>
            </circle>
            <circle cx="12" cy="12" r="0">
                <animate attributeName="opacity" values="0;1;0"
                        keyTimes="0;.05;1" calcMode="linear"
                        dur="1.5s" begin=".1.5s" repeatCount="indefinite"/>
                <animate attributeName="r" from="0" to="12"
                        dur="1.5s" begin=".1.5s" repeatCount="indefinite"/>
            </circle>
            <circle cx="12" cy="12" r="0">
                <animate attributeName="opacity" values="0;1;0"
                        keyTimes="0;.05;1" calcMode="linear"
                        dur="1.5s" begin=".6s" repeatCount="indefinite"/>
                <animate attributeName="r" from="0" to="12"
                        dur="1.5s" begin=".6s" repeatCount="indefinite"/>
            </circle>
        </svg>
    )
}